import { createSlice } from "@reduxjs/toolkit";
import { defaultReducers } from "../helper/reducer";

const INITIAL_STATE = {
  status: "IDLE",
  data: {
    allOrders: null,
    latestOrders: null,
    activeOrders: null,
    archivedOrders: null,
    pastOrders: null,
    assignedOrder: null,
  },
};

const ordersSlice = createSlice({
  name: "orders",
  initialState: INITIAL_STATE,
  reducers: {
    ...defaultReducers,
    setAllOrders(state, action) {
      state.data.allOrders = action.payload.allOrders;
      state.data.latestOrders = action.payload.latestOrders;
      state.data.activeOrders = action.payload.activeOrders;
      state.data.archivedOrders = action.payload.archivedOrders;
      state.data.pastOrders = action.payload.pastOrders;
      return state;
    },
    setAssignedOrder(state, action) {
      state.data.assignedOrder = action.payload;
      return state;
    },
  },
});

export default ordersSlice;
